import PropTypes from 'prop-types';

// Mirrors AuditRow.to_dict in dashboard/adnets/audit/model.py.

export const auditDeltaShape = PropTypes.shape({
    adnet_value: PropTypes.number,
    singular_value: PropTypes.number,
    percent: PropTypes.number,
});

const auditPeerShape = PropTypes.shape({
    uan_id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
});

export const auditAccountShape = PropTypes.shape({
    account_id: PropTypes.string.isRequired,
    name: PropTypes.string,
    deltas: PropTypes.objectOf(auditDeltaShape).isRequired,
    shared_with: PropTypes.arrayOf(auditPeerShape),
    loaded_under: auditPeerShape,
});

export const auditRowShape = PropTypes.shape({
    uan_id: PropTypes.number.isRequired,
    adnetwork: PropTypes.string.isRequired,
    display_name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    can_calculate: PropTypes.bool.isRequired,
    logo_path: PropTypes.string,
    pulled_at: PropTypes.string,
    checked_by: PropTypes.string,
    loaded_after_check: PropTypes.bool,
    loads: PropTypes.arrayOf(
        PropTypes.shape({
            account: PropTypes.string,
            account_id: PropTypes.string,
            pull_tag: PropTypes.string,
            loaded_at: PropTypes.string,
        })
    ),
    show_in_archive: PropTypes.bool,
    unsupported_reason: PropTypes.string,
    audit_uan_id: PropTypes.number,
    deltas: PropTypes.objectOf(auditDeltaShape).isRequired,
    accounts: PropTypes.arrayOf(auditAccountShape),
    inactive_since: PropTypes.string,
});
